import { clearUserDataFromStore, updateStore } from 'core_main/store';
import { importAndInitializePubNub } from 'core_main/globals/vendors';

export const stop = () => {
  return importAndInitializePubNub().then((pubnub) => {
    clearUserDataFromStore();
    pubnub.stopPubNub();
    updateStore('isPubNubConnected', false);
  });
};
